module.exports = __webpack_public_path__ + "static/media/45_B.447237d1.png";